export default "__VITE_ASSET__BJ3fD3qQ__"